import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const uploadRestaurantLogoFileHttps = createAsyncThunk(
  "restaurant/uploadRestaurantLogoFileHttps",
  async (data: any, { rejectWithValue }) => {
    try {
      const headers = new Headers({
        "x-goog-acl": "public-read",
        "Content-Type": `image/${data.extention}`,
      });
      await fetch(data.url, {
        method: "PUT",
        headers: headers,
        body: data.body,
      });
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  isInitialSlectReastaurant: false,
  selectedRestaurantDetails: null,
  selectedRestaurantId: localStorage.getItem("selectedRestaurantId") || "",
  isRestaurantSelected: false,
};

export const reastaurantSlice = createSlice({
  name: "reastaurant",
  initialState,
  reducers: {
    openInitialSlectReastaurantModla: (state, action) => {
      state.isInitialSlectReastaurant = action.payload;
      state.isRestaurantSelected = action.payload;
    },
    setSelectedRestaurantId(state, action) {
      state.selectedRestaurantId = action.payload;
      localStorage.setItem("selectedRestaurantId", action.payload);
    },
    setSelectedRestaurantDetails: (state, action) => {
      state.selectedRestaurantDetails = action.payload;
    },
  },
});

export const {
  openInitialSlectReastaurantModla,
  setSelectedRestaurantDetails,
} = reastaurantSlice.actions;

export default reastaurantSlice.reducer;
